import React, { Component } from "react";
import ReactHtmlParser from "react-html-parser";
import PerfectScrollbar from "react-perfect-scrollbar";
import { appendUserTextMessage, guidGenerator, handleInvalidImage, isAndroid, isiPhone, isMobileDevice, scrollBot } from "../utils/general";
import BotMessageButtons from "../elements/BotMessageButtons";
import BotMessageFeedbackButtons from "../elements/BotMessageFeedbackButtons";
import BotMessageDropdown from "../elements/BotMessageDropdown";
import BotMessageText from "../elements/BotMessageText";
import BotMessageTextNoIcon from "../elements/BotMessageTextNoIcon";
import BotMessageWrap from "../elements/BotMessageWrap";
import Button from "../elements/Buttons";
import Loader from "../elements/Loader";
import VerySatisfied from "../elements/feedback_svg/VerySatisfied";
import Satisfied from "../elements/feedback_svg/Satisfied";
import Neutral from "../elements/feedback_svg/Neutral";
import Dissatisfied from "../elements/feedback_svg/Dissatisfied";
import VeryDissatisfied from "../elements/feedback_svg/VeryDissatisfied";
import UploadFile from "../elements/UploadFile";
import DatePicker from "../elements/DatePicker";
import BotMessageGroupButtons from "../elements/BotMessageGroupButtons";
import ButtonSVGIcons from "../elements/ButtonIcons";
import iconLists from "../../data/icon-lists";
import ExtraButtons from "./ExtraButtons";
import CardElement from "../elements/cards";
// import html2canvas from 'html2canvas';
import { toPng } from "html-to-image";
import downloadjs from "downloadjs";
import ButtonSVG from "../elements/ButtonIcons24";
import { btnIconList } from "../../data/button-icon-list";
import { BotBubbleSvg } from "../utils/svg-icons-24";
import { innerLinks } from "../../data/link-store";
import RSelect from 'react-select';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import "overlayscrollbars/styles/overlayscrollbars.css";

class MessageContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      messageListsData: this.props.messageLists,
      isSelected: this.props.isSelected,
      selectedFile: this.props.selectedFile,
      dropdownSize: 3,
      isScrolled: false,
      isShowBack: true,
      disableBack: false,
      isDownload: false,
      tout: 0,
      isOTPExpired: false,
      otpExpireTime: this.props.isTest? 10 : 60,
      feedbackVal: 0,
    };
    this.buttonRef = React.createRef();
    this.scrollbarRef = React.createRef();
  }

  componentDidUpdate() {
    // Ensure scrollbar updates on component updates
    const array = this.state.messageListsData;
    this.updateScrollbar();
    const lastInputType = array[array.length - 1]?.data?.ndata?.inputType;
    if(lastInputType==="invalidimage"){
      setTimeout(() => {
        handleInvalidImage()
      }, 500);
    }
  }

  updateScrollbar = () => {
    // Access the scrollbar instance and call update if available
    const osInstance = this.scrollbarRef.current?.osInstance();
    if (osInstance) {
      osInstance.update(); // This will refresh the scrollbar's state
    }
  };

  handleExportPDF = async (uielement, lang) => {
    try {
      const node = document.querySelector("#" + uielement);
      let nfilename = "card_" + "_" + Date.now() + ".png";
      let fonts = lang === "ar" ? `SEC_GE_Light` : `ABCFVAR-Regular`;
      let directions = lang === "ar" ? `rtl` : `ltr`;

      // Ensure the font is fully loaded before capturing
      await document.fonts.load("16px SEC_GE_Light");

      // Calculate the scale factor
      const scale = 1;
      const width = node.offsetWidth * scale;
      const height = node.offsetHeight * scale;

      // Apply scaling styles
      const style = {
        transform: `scale(${scale})`,
        transformOrigin: "top left",
        width: `${node.offsetWidth}px`,
        height: `${node.offsetHeight}px`,
        fontFamily: fonts,
        backgroundImage: `linear-gradient(315deg, #fff 10%, #ffecdc 85%)`,
        direction: directions,
      };

      // Create a temporary wrapper to apply the styles
      const wrapper = document.createElement("div");
      wrapper.appendChild(node.cloneNode(true));
      wrapper.style.position = "absolute";
      wrapper.style.bottom = 0;
      wrapper.style.right = 0;
      wrapper.style.zIndex = -2;
      wrapper.style.width = `${width}px`;
      wrapper.style.height = `${height}px`;
      wrapper.firstChild.style.transform = style.transform;
      wrapper.firstChild.style.transformOrigin = style.transformOrigin;
      wrapper.firstChild.style.width = style.width;
      wrapper.firstChild.style.backgroundImage = style.backgroundImage;
      wrapper.firstChild.style.direction = style.direction;
      wrapper.style.fontFamily = fonts;
      document.body.appendChild(wrapper);

      // Capture the node as an image
      const dataUrl = await toPng(wrapper.firstChild, {
        width,
        height,
        cacheBust: true,
      });

      // Clean up the temporary wrapper
      document.body.removeChild(wrapper);

      // console.log(dataUrl);
      downloadjs(dataUrl, nfilename, "image/png");
    } catch (error) {
      console.error("Failed to capture image:", error);
    }
  };

  componentWillReceiveProps(newProps) {
    if (newProps.messageLists) {
      // console.log(newProps.messageLists);
      this.setState({ messageListsData: newProps.messageLists }, () => {
        /* console.log(this.state.messageListsData); */
      });
    }
    if (newProps.isSelected || newProps.selectedFile) {
      // console.log(newProps.messageLists);
      this.setState({
        selectedFile: newProps.selectedFile,
        isSelected: newProps.isSelected,
      });
    }
    this.updateFeedbackBtnState();
  }

  updateFeedbackBtnState = () => {
    this.setState({ isOTPExpired: false });
  };

  onClickDDHandler = (e) => {
    e.preventDefault();
    // console.log(e.target.nextSibling.className);
    let ne = e.target.nextSibling;
    if (ne.style.display == "block") {
      ne.style.display = "none";
      e.target.classList.toggle("sactive");
    } else {
      ne.style.display = "block";
      e.target.classList.toggle("sactive");
      setTimeout(() => {
        scrollBot();
      }, 150);
    }
  };

  updateStatus = () => {
    this.setState({ isScrolled: true });
  };

  getSVGs = (val) => {
    // const index = iconLists.findIndex((element) => {
    const index = btnIconList.findIndex((element) => {
    // console.log(element);
    //   console.log(val);
      if (element.original_english === val) {
        return true;
      } else if (element.original_arabic === val) {
        return true;
      }

      return false;
    });

    // console.log(index); // ðŸ‘‰ï¸ 0

    if (index !== -1) {
      // ðŸ‘‰ï¸ object is contained in array
      // console.log(iconLists[index].english);
      // console.log(btnIconList[index].btns);
      if (this.props.language && this.props.language === "ar") {
        return [btnIconList[index].arabic, btnIconList[index].btns];
      } else {
        return [btnIconList[index].english, btnIconList[index].btns];
      }
    } else {
      return -1;
    }
  };

  timeOut = () => {
    var period = this.state.otpExpireTime;
    let trem1 = 0;
    this.state.tout = setInterval(() => {
      period = period - 1;
      trem1 = period;
      if (trem1 <= this.state.otpExpireTime) {
        if (trem1 === 0) {
          this.setState({ isOTPExpired: true });
          clearInterval(this.state.tout);
        } else {
          $(".otptime:last").html(trem1);
        }
      }
    }, 1000);
  };

  handleMouseEnter = (e) => {
    const dataName = parseInt(e.currentTarget.getAttribute('data-name'), 10);
    this.setState({ feedbackVal: dataName });
  };

  handleMouseLeave = () => {
    this.setState({ feedbackVal: 0 });
  };

  isEmptyObj=(obj)=>{
    return Object.keys(obj).length === 0;
  }

  componentDidMount() {
    if (this.buttonRef.current) {
      this.buttonRef.current.focus();
    }
  }

  render() {
    const { language, filebase64, compressionProgress } = this.props;
    const { feedbackVal } = this.state;
    // console.log('Feed val: ', feedbackVal)
    return (
      <div
        id="conversation-group"
        className={this.state.isScrolled ? "scroll-activated" : ""}
        role="log"
      >
        <PerfectScrollbar
          className="conversation-group"
          // suppressScrollX='true'
          onScrollY={this.updateStatus}
          suppressScrollX={true}
        >
          <div
            id="messages"
            aria-live="polite"
            aria-atomic="false"
            data-testid="messagesLog"
            className="message-container"
          >
            {/* {console.log(this.state.messageListsData.length)} */}
            {this.state.messageListsData &&
            this.state.messageListsData.length > 0 ? (
              this.state.messageListsData.map((el, idx, array) => {
                // console.log(el.data);
                if (
                  el.data.ndata.status === 500 ||
                  el.data.ndata.status === 404
                ) {
                  return (
                    <BotMessageWrap>
                      <BotMessageText
                        botTitle={this.props.botTitle}
                        isIcon={true}
                      >{el.data.ndata.message}</BotMessageText>
                    </BotMessageWrap>
                  );
                } else {
                  let msgs = JSON.parse(el.data.ndata.message);
                  let uuid = `element_${idx}` + guidGenerator();
                  let btnElements = false;
                  let feedBtnElements = false;
                  let dropdownElements = false;
                  let haveNickname = false;
                  let isAnyMobile = false;
                  let accOptions = [];
                  let firstOption = {};
                  let userParamsElements = false;
                  let propertyParamsElements = false;
                  let accParamsElements = false;
                  let accNameParamsElements = false;
                  let billParamsElements = false;
                  let inputTypeElements = "";
                  let base64Link = "";
                  let downloadFileName = "";
                  let userParamsValues = [];
                  let edata = el.data.ndata;
                  let duuid = "dd_" + uuid + idx;
                  let fullName = "";
                  let mobileNumber = "";
                  let contractNumber = "";
                  let chatTranscript = "";
                  let entryPointId = "";
                  let templateName = "";
                  let locale = "";
                  let propContractNo = "";
                  let propMeterNo = "";
                  let propertyName = "";
                  let selectAnOptionLabel = "Select an option";
                  let selectAnOptionLabelAccount =
                    "select the account number";
                  let selectAnOptionLabelRequest = "Select request number";
                  let agentBtnTitle = "Start the conversation";
                  let click2copy = "Click to copy";
                  let click2edit = "Click to edit";
                  let click2add = "Click to add";
                  let backBtnName = "Back";
                  let aliasName = "Property Name:";
                  let contractName = "Contract Number:";
                  let meterName = "Meter Number: ";
                  let isHelloMsg = idx === 0 ? true : false;
                  let helloMessage =
                    "Welcome, to the Saudi Electricity Company's Interactive Service.";
                  let accountNumTitle = "Account Number";
                  let roleTitle = "Role";
                  let meterNumTitle = "Meter Number";
                  let nicknameTitle = "Nickname";
                  let totalAmountTitle = "Total Amount";
                  let remainingAmountTitle = "Remaining Amount";
                  let alreadyPaidTitle = "Paid Amount";
                  let OTPExpiredMessage =
                    "You can resend an OTP in <span class='otptime Tnumber'>60</span> seconds";
                  let invalidImgMessage =
                    "Please upload valid file.\nAllowed Formats: jpg, png, pdf, doc, docx. File size not greater than 5.5 MB.";
                  if (language && language === "ar") {
                    downloadFileName = "Sec_billing.pdf";
                    selectAnOptionLabel = "حدد خيارا";
                    selectAnOptionLabelAccount = "حدد رقم الحساب";
                    selectAnOptionLabelRequest = "حدد رقم الطلب";
                    agentBtnTitle = "بدء المحادثة";
                    propertyName = "تغيير اسم العقار";
                    backBtnName = "الرجوع للخلف";
                    helloMessage =
                      "حياك الله, معك الخدمة التفاعلية من السعودية للكهرباء";
                    aliasName = "مسمى الملكية";
                    contractName = "رقم حسابك";
                    meterName = "رقم العداد";
                    accountNumTitle = "رقم الحساب";
                    roleTitle = "نوع الاستفادة";
                    meterNumTitle = "رقم العداد";
                    nicknameTitle = "الاسم المستعار";
                    totalAmountTitle = "إجمالي المبلغ";
                    remainingAmountTitle = "المبلغ المتبقي";
                    alreadyPaidTitle = "المبلغ المسدد";
                    OTPExpiredMessage =
                      "إعادة إرسال رمز التحقق بعد <span class='otptime Tnumber'>60</span> ثانية";
                    invalidImgMessage = "يرجى تحميل ملف صالح. \n التنسيقات المسموح بها: jpg، png، pdf، doc، docx. حجم الملف لا يزيد عن 5.5 ميغا بايت.";
                  } else {
                    downloadFileName = "Sec_billing.pdf";
                    selectAnOptionLabel = "Select an option";
                    selectAnOptionLabelAccount =
                      "select the account number";
                    selectAnOptionLabelRequest = "Select request number";
                    agentBtnTitle = "Start the conversation";
                    propertyName = "Change Property Name";
                    backBtnName = "Back";
                    helloMessage =
                      "Welcome, to the Saudi Electricity Company's Interactive Service..";
                    aliasName = "Property Name";
                    contractName = "Contract Number";
                    meterName = "Meter Number";
                    accountNumTitle = "Account Number";
                    roleTitle = "Role";
                    meterNumTitle = "Meter Number";
                    nicknameTitle = "Nickname";
                    totalAmountTitle = "Total Amount";
                    remainingAmountTitle = "Remaining Amount";
                    alreadyPaidTitle = "Paid Amount";
                    OTPExpiredMessage =
                      "You can resend an OTP in <span class='otptime Tnumber'>60</span> seconds";
                    invalidImgMessage =
                      "Please upload valid file.\nAllowed Formats: jpg, png, pdf, doc, docx. File size not greater than 5.5 MB.";
                  }

                  const getCardData = (values) => {
                    return values.map((item) => {
                      let icon = "";
                      let title = "";
                      let value = item.value;
                      switch (item.name) {
                        case "contract_number":
                          icon = "account";
                          title = accountNumTitle;
                          break;
                        case "meter_number":
                          icon = "meter";
                          title = meterNumTitle;
                          break;
                        case "role":
                          icon = "role";
                          title = roleTitle;
                          break;
                        case "property_name":
                          icon = "nickname";
                          title = nicknameTitle;
                          break;
                        case "total_amount":
                          icon = "amount";
                          title = totalAmountTitle;
                          break;
                        case "remaining_amount":
                          icon = "amount";
                          title = remainingAmountTitle;
                          break;
                        case "already_paid":
                          icon = "paid";
                          title = alreadyPaidTitle;
                          break;
                        default:
                          break;
                      }
                      return { icon, title, value };
                    });
                  };

                  // Check if property found
                  if (Object.prototype.hasOwnProperty.call(edata, "element")) {
                    // console.log("Is element");
                    let elemnt = edata.element;
                    btnElements = Object.prototype.hasOwnProperty.call(
                      elemnt,
                      "Btns"
                    );
                    dropdownElements = Object.prototype.hasOwnProperty.call(
                      elemnt,
                      "dropdown"
                    );
                    userParamsElements = Object.prototype.hasOwnProperty.call(
                      elemnt,
                      "userParam"
                    );
                    propertyParamsElements =
                      Object.prototype.hasOwnProperty.call(
                        elemnt,
                        "propertyParam"
                      );
                    feedBtnElements = Object.prototype.hasOwnProperty.call(
                      elemnt,
                      "feedbackBtn"
                    );
                    accParamsElements = Object.prototype.hasOwnProperty.call(
                      elemnt,
                      "AccParam"
                    );
                    accNameParamsElements =
                      Object.prototype.hasOwnProperty.call(
                        elemnt,
                        "AccNameParam"
                      );
                    billParamsElements = Object.prototype.hasOwnProperty.call(
                      elemnt,
                      "BillParam"
                    );
                  }
                  // Check and set inputType
                  if (
                    Object.prototype.hasOwnProperty.call(edata, "inputType")
                  ) {
                    inputTypeElements = edata.inputType;
                  }
                  if (
                    inputTypeElements === "InvoicePdf" &&
                    Object.prototype.hasOwnProperty.call(edata, "invoicePdf")
                  ) {
                    base64Link = edata.invoicePdf;
                  }

                  if (inputTypeElements === "Account") {
                    //AccountInfo / BillInfo
                    selectAnOptionLabel = selectAnOptionLabelAccount;
                  } else if (inputTypeElements === "Request" || inputTypeElements === "UDS" ) {
                    selectAnOptionLabel = selectAnOptionLabelRequest;
                  } else if (inputTypeElements === "PaymentMode") {
                    selectAnOptionLabel = selectAnOptionLabel;
                  }
                  let card_rawdata = [];
                  let card_data = [];
                  if (inputTypeElements === "BillInfo") {
                    card_rawdata = el.data.ndata.element.BillParam.Values;
                    card_data = getCardData(card_rawdata);
                  } else if (inputTypeElements === "AccountInfoWithoutName") {
                    card_rawdata = el.data.ndata.element.AccParam.Values;
                    card_data = getCardData(card_rawdata);
                  } else if (inputTypeElements === "AccountInfoWithName") {
                    card_rawdata = el.data.ndata.element.AccNameParam.Values;
                    card_data = getCardData(card_rawdata);
                  }

                  if (inputTypeElements === "OTP") {
                    clearInterval(this.state.tout);
                    this.timeOut();
                  } else {
                    clearInterval(this.state.tout);
                  }

                  if(dropdownElements){
                    const options = el.data.ndata.element.dropdown.options;
                    haveNickname = options.some(option => 'nickname' in option);
                    firstOption = options && options.length>0 ? options[0]:{};
                    isAnyMobile = isMobileDevice() && (isiPhone() || isAndroid());
                    accOptions = options?.map(({ value, nickname }) => ({
                      value,
                      label: nickname ? `${value} - ${nickname}` : value,
                    })) || [];
                  } else {
                    accOptions = [];
                    firstOption = {};
                    isAnyMobile = false;
                  }

                  const replaceLinks = (text) => {
                    // Replace <Link> elements
                    text = text.replace(/<Link>(.*?)<\/Link>/g, (_, label) => {
                      const key = label.trim();
                      const url = innerLinks[key]?.Production?.[language.toUpperCase()];
                      const anchorText = innerLinks[key]?.label?.[language.toUpperCase()];
                      return url ? `<a target="_blank" class="intLink" href="${url}">${anchorText}</a>` : `${key}`;
                    });
                  
                    // Replace <Links> elements
                    text = text.replace(/<Links>(.*?)<\/Links>/g, (_, label) => {
                      const key = label.trim();
                      const url = innerLinks[key]?.Staging?.[language.toUpperCase()];
                      const anchorText = innerLinks[key]?.label?.[language.toUpperCase()];
                      return url ? `<a target="_blank" class="intLink" href="${url}">${anchorText}</a>` : `${key}`;
                    });
                  
                    return text;
                  };

                  const isInvalidImg = inputTypeElements==='invalidimage';

                  return (
                    <BotMessageWrap key={idx}>
                      {/* * Handle bubble text
                       * with/without Bot Icon -- Not */}
                      {/* * Handle bubble text
                       * with/without Click here / Pdf link */}
                      {/* * Handle bubble text
                       * with/without Copy / paste */}
                      {msgs.map((msg, id, arr) => {
                        if (
                          feedBtnElements &&
                          (accNameParamsElements ||
                            billParamsElements ||
                            accParamsElements)
                        ) {
                          //do nothing
                        } else {
                          if (
                            id === 0 &&
                            id === arr.length - 1 &&
                            !dropdownElements &&
                            !propertyParamsElements
                          ) {
                            return (
                              <BotMessageText
                                classN={`one${isInvalidImg?' invalid-ele':''}`}
                                copyBtnHandler={this.props.copyBtnHandler}
                                editBtnHandler={this.props.editBtnHandler}
                                botTitle={this.props.botTitle}
                                isIcon={true}
                                key={id}
                                isAgent={this.props.isAgent}
                                time={"11:00PM"}
                              >
                                {/* {ReactHtmlParser(replaceLinks(msg.text))} */}
                                {ReactHtmlParser(isInvalidImg? invalidImgMessage : replaceLinks(msg.text))}
                              </BotMessageText>
                            );
                          } else if (
                            id === 0 &&
                            id === arr.length - 1 &&
                            !dropdownElements &&
                            propertyParamsElements
                          ) {
                            let sept = msg.text.split("\n");
                            let pNm = "";
                            if (sept[sept.length - 1].includes("propName")) {
                              pNm = $(sept[sept.length - 1]).text();
                            }
                            if (sept[sept.length - 2].includes("propMeter")) {
                              propMeterNo = $(sept[sept.length - 2]).text();
                            }
                            if (
                              sept[sept.length - 3].includes("propContract")
                            ) {
                              propContractNo = $(sept[sept.length - 3]).text();
                            }
                            return (
                              <BotMessageText
                                classN="six message-properties"
                                key={id}
                                copyBtnHandler={this.props.copyBtnHandler}
                                editBtnHandler={this.props.editBtnHandler}
                                botTitle={this.props.botTitle}
                                isIcon={true}
                                isAgent={this.props.isAgent}
                                time={"11:00PM"}
                              >
                                {ReactHtmlParser(sept[0])}
                                {contractName}:&nbsp;
                                {ReactHtmlParser(sept[sept.length - 3])}&nbsp;
                                <Button
                                  key={`ccn-${uuid}`}
                                  id={`ccn-${duuid}`}
                                  classes="copyLink"
                                  // title={click2copy}
                                  hoverTitle={click2copy}
                                  action={this.props.copyBtnHandler}
                                  dvalue={propContractNo}
                                />
                                <br />
                                {meterName}:&nbsp;
                                {ReactHtmlParser(sept[sept.length - 2])}&nbsp;
                                <Button
                                  key={`cmn-${uuid}`}
                                  id={`cmn-${duuid}`}
                                  classes="copyLink"
                                  // title={click2copy}
                                  hoverTitle={click2copy}
                                  action={this.props.copyBtnHandler}
                                  dvalue={propMeterNo}
                                />
                                <br />
                                {pNm === "" ? (
                                  <>
                                    {aliasName}:&nbsp;
                                    {ReactHtmlParser(sept[sept.length - 1])}
                                    &nbsp;
                                    <Button
                                      key={`pn-${uuid}`}
                                      id={`pn-${duuid}`}
                                      classes="addLink"
                                      // title={click2edit}
                                      hoverTitle={click2add}
                                      action={this.props.editBtnHandler}
                                      dvalue={propertyName}
                                    />{" "}
                                  </>
                                ) : (
                                  <>
                                    {aliasName}:&nbsp;
                                    {ReactHtmlParser(sept[sept.length - 1])}
                                    &nbsp;
                                    <Button
                                      key={`pn-${uuid}`}
                                      id={`pn-${duuid}`}
                                      classes="editLink"
                                      // title={click2edit}
                                      hoverTitle={click2edit}
                                      action={this.props.editBtnHandler}
                                      dvalue={propertyName}
                                    />{" "}
                                  </>
                                )}
                              </BotMessageText>
                            );
                          } else if (
                            id === 0 &&
                            id !== arr.length - 1 &&
                            inputTypeElements === "InvoicePdf"
                          ) {
                            return (
                              <BotMessageText
                                classN="seven"
                                key={id}
                                botTitle={this.props.botTitle}
                                isIcon={true}
                              >
                                {ReactHtmlParser(replaceLinks(msg.text))}
                                <a
                                  href={`data:application/pdf;base64,${base64Link}`}
                                  className="intLink pdfLink"
                                  download={downloadFileName}
                                >
                                  {this.props.language &&
                                  this.props.language === "ar"
                                    ? "Ø¹Ø±Ø¶ ÙØ§ØªÙˆØ±ØªÙŠ"
                                    : "Click here"}
                                </a>
                              </BotMessageText>
                            );
                          } else if (
                            id === 0 &&
                            id !== arr.length - 1 &&
                            inputTypeElements !== "InvoicePdf"
                          ) {
                            return (
                              <BotMessageText
                                classN="two"
                                copyBtnHandler={this.props.copyBtnHandler}
                                editBtnHandler={this.props.editBtnHandler}
                                key={id}
                                botTitle={this.props.botTitle}
                                isIcon={true}
                                isAgent={this.props.isAgent}
                                time={"11:00PM"}
                              >
                                {ReactHtmlParser(replaceLinks(msg.text))}
                              </BotMessageText>
                            );
                          } else if (id > 0 && id !== arr.length - 1) {
                            return (
                              <BotMessageTextNoIcon classN="three" key={id} isAgent={this.props.isAgent} time={"11:00PM"}>
                                {ReactHtmlParser(replaceLinks(msg.text))}
                              </BotMessageTextNoIcon>
                            );
                          } else if (id > 0 && id === arr.length - 1) {
                            return (
                              <BotMessageTextNoIcon classN="four" key={id} isAgent={this.props.isAgent} time={"11:00PM"}>
                                {ReactHtmlParser(replaceLinks(msg.text))}
                              </BotMessageTextNoIcon>
                            );
                          } else {
                            return (
                              <BotMessageText
                                classN="five"
                                copyBtnHandler={this.props.copyBtnHandler}
                                editBtnHandler={this.props.editBtnHandler}
                                key={id}
                                botTitle={this.props.botTitle}
                                isIcon={true}
                                isAgent={this.props.isAgent}
                                time={"11:00PM"}
                              >
                                {ReactHtmlParser(replaceLinks(msg.text))}
                              </BotMessageText>
                            );
                          }
                        }
                      })}

                      {btnElements && inputTypeElements === "Location" ? (
                        <React.Fragment>
                          <BotMessageButtons>
                            {el.data.ndata.element.Btns.Buttons.map(
                              (btn, bid) => {
                                return (
                                  <Button
                                    key={bid}
                                    id={`location${bid}`}
                                    classes="btnLocation"
                                    title={btn.name}
                                    hoverTitle={btn.name}
                                    action={this.props.btnActions}
                                  />
                                );
                              }
                            )}
                          </BotMessageButtons>
                        </React.Fragment>
                      ) : btnElements && inputTypeElements === "File" ? (
                        <React.Fragment>
                          <BotMessageButtons>
                            {el.data.ndata.element.Btns.Buttons.map(
                              (btn, bid) => {
                                return (
                                  <UploadFile
                                    key={`fileupload${bid}`}
                                    title={btn.name}
                                    rounded="false"
                                    changeHandler={this.props.changeHandler}
                                    btnChangeHandler={
                                      this.props.btnChangeHandler
                                    }
                                    isSelected={this.props.isSelected}
                                    selectedFile={this.props.selectedFile}
                                    filevalue={this.props.filevalue}
                                    removeFileHandler={
                                      this.props.removeFileHandler
                                    }
                                    acceptFormat={this.props.acceptFormat}
                                    language={this.props.language}
                                    filebase64={filebase64}
                                    compressionProgress={compressionProgress}
                                  />
                                );
                              }
                            )}
                          </BotMessageButtons>
                        </React.Fragment>
                      ) : btnElements && inputTypeElements === "DatePicker" ? (
                        <React.Fragment>
                          <BotMessageButtons>
                            <DatePicker
                              datePicAction={this.props.datePicAction}
                            />
                          </BotMessageButtons>
                        </React.Fragment>
                      ) : btnElements && inputTypeElements === "Agent" ? (
                        <BotMessageButtons>
                          {el.data.ndata.element.Btns.Buttons.map(
                            (paramv, pid) => {
                              let uuuid = uuid + "_" + pid;
                              let ch = "";
                              if (paramv.Values) {
                                userParamsValues = paramv.Values;
                                userParamsValues.map((parmv, ppid) => {
                                  if (ppid === 0) {
                                    fullName = parmv.value || "test";
                                  }
                                  if (ppid === 1) {
                                    mobileNumber = parmv.value || "00000000";
                                  }
                                  if (ppid === 2) {
                                    contractNumber = parmv.value || "22222222";
                                  }
                                  if (ppid === 3) {
                                    if (parmv.value === "") {
                                      ch =
                                        "+%0ACustomer%3A+hi+%0ABot%3A++%D8%AD%D9%8A%D8%A7%D9%83+%D8%A7%D9%84%D9%84%D9%87+%E2%80%8B%E2%80%8B+%D9%83%D9%8A%D9%81+%D8%A3%D9%82%D8%AF%D8%B1+%D8%A3%D8%B3%D8%A7%D8%B9%D8%AF%D9%83%D8%9F";
                                    } else {
                                      ch = parmv.value;
                                    }
                                    chatTranscript = ch;
                                  }
                                  if (parmv.name === 'entryPointId') entryPointId = parmv.value;
                                  if (parmv.name === 'templateName') templateName = parmv.value;
                                  if (parmv.name === 'locale') locale = parmv.value;
                                });

                                return (
                                  <Button
                                    key={pid}
                                    id={uuuid}
                                    classes="btnAgentLink"
                                    title={agentBtnTitle}
                                    hoverTitle={agentBtnTitle}
                                    action={this.props.btnActions}
                                    fname={fullName}
                                    mobile={mobileNumber}
                                    contractno={contractNumber}
                                    chathistory={chatTranscript}
                                    entryPointId={entryPointId}
                                    templateName={templateName}
                                    locale={locale}
                                  />
                                );
                              } else {
                                return (
                                  <Button
                                    key={pid}
                                    id={uuuid}
                                    classes="btnClass"
                                    title={paramv.name}
                                    hoverTitle={paramv.name}
                                    action={this.props.btnActions}
                                  />
                                );
                              }
                            }
                          )}
                        </BotMessageButtons>
                      ) : btnElements && inputTypeElements === "Submenu" ? (
                        <BotMessageGroupButtons>
                          {el.data.ndata.element.Btns.Buttons.map(
                            (btn, bid) => {
                              let fuuid = uuid + "_" + bid;
                              let btnin = [];
                              btnin = this.getSVGs(btn.name);
                              return (
                                <Button
                                  key={`gbtn${bid}`}
                                  id={`gbtn${fuuid}`}
                                  classes="btnGroupClass"
                                  hoverTitle={btn.name}
                                  svg="true"
                                  action={this.props.btnActions}
                                >
                                  <ButtonSVG
                                    name={btnin[0]}
                                    title={btnin[1]}
                                    color=""
                                  />
                                </Button>
                              );
                            }
                          )}
                        </BotMessageGroupButtons>
                      ) : btnElements && inputTypeElements==="Mainmenu" ? (
                        <BotMessageGroupButtons>
                          {el.data.ndata.element.Btns.Buttons.map(
                            (btn, bid) => {
                              let fuuid = uuid + "_" + bid;
                              let btnin = [];
                              btnin = this.getSVGs(btn.name);
                              return (
                                <Button
                                  key={`gbtn${bid}`}
                                  id={`gbtn${fuuid}`}
                                  classes="btnGroupClass"
                                  hoverTitle={btn.name}
                                  svg="true"
                                  action={this.props.btnActions}
                                >
                                  <ButtonSVG
                                    name={btnin[0]}
                                    title={btnin[1]}
                                    color=""
                                  />
                                </Button>
                              );
                            }
                          )}
                        </BotMessageGroupButtons>
                      ) : btnElements && inputTypeElements ==="lastMessage"?(
                        <BotMessageButtons>
                          {el.data.ndata.element.Btns.Buttons.map(
                            (btn, bid) => {
                              let fuuid = uuid + "_" + bid;
                              return <button
                                key={bid}
                                ref={this.buttonRef}
                                className="btnClass btnLm"
                                id={fuuid}
                                type="button"
                                title={btn.name}
                                onClick={this.props.btnActions}
                                onTouchEnd={this.props.btnActions}
                              >{btn.name}</button>
                            })}
                        </BotMessageButtons>
                      ) : btnElements && inputTypeElements === "InvoicePdf"? (
                        <BotMessageButtons>
                          {el.data.ndata.element.Btns.Buttons.map(
                            (btn, bid) => {
                              let fuuid = uuid + "_" + bid;
                              return ["Other","أخرى"].includes(btn.name)?(
                                <div className="btn-break">
                                  <Button
                                    key={bid}
                                    id={fuuid}
                                    classes={"btnClass btnClassNl"}
                                    title={btn.name}
                                    hoverTitle={btn.name}
                                    action={this.props.btnActions}
                                    onTouchEnd={this.props.btnActions}
                                  />
                                </div>
                              ):<>
                                {inputTypeElements==="lastMessage"?
                                <Button
                                  // ref={this.buttonRef}
                                  key={bid}
                                  id={fuuid}
                                  classes={"btnClass"}
                                  title={btn.name}
                                  hoverTitle={btn.name}
                                  action={this.props.btnActions}
                                />
                                :
                                <Button
                                  key={bid}
                                  id={fuuid}
                                  classes={"btnClass"}
                                  title={btn.name}
                                  hoverTitle={btn.name}
                                  action={this.props.btnActions}
                                />}
                              </>
                            }
                          )}
                        </BotMessageButtons>
                      ) : btnElements && inputTypeElements === "NationalId"? (
                        <BotMessageButtons>
                          {el.data.ndata.element.Btns.Buttons.map(
                            (btn, bid) => {
                              let fuuid = uuid + "_" + bid;
                              return ["Other","أخرى"].includes(btn.name)?(
                                <div className="btn-break">
                                  <Button
                                    key={bid}
                                    id={fuuid}
                                    classes={"btnClass btnClassNl"}
                                    title={btn.name}
                                    hoverTitle={btn.name}
                                    action={this.props.btnActions}
                                    onTouchEnd={this.props.btnActions}
                                  />
                                </div>
                              ):<>
                                {inputTypeElements==="lastMessage"?
                                <Button
                                  // ref={this.buttonRef}
                                  key={bid}
                                  id={fuuid}
                                  classes={"btnClass"}
                                  title={btn.name}
                                  hoverTitle={btn.name}
                                  action={this.props.btnActions}
                                />
                                :
                                <Button
                                  key={bid}
                                  id={fuuid}
                                  classes={"btnClass"}
                                  title={btn.name}
                                  hoverTitle={btn.name}
                                  action={this.props.btnActions}
                                />}
                              </>
                            }
                          )}
                        </BotMessageButtons>
                      ) : btnElements && inputTypeElements === "OTP" ? (
                        <BotMessageButtons>
                          {el.data.ndata.element.Btns.Buttons.map(
                            (btn, bid) => {
                              let fuuid = uuid + "_" + bid;
                              return (
                                <>
                                  {this.state.isOTPExpired &&
                                  <Button
                                    key={bid}
                                    id={fuuid}
                                    classes="btnClass btn-otp-resend"
                                    title={btn.name}
                                    hoverTitle={btn.name}
                                    action={this.props.btnActions}
                                    disabled={!this.state.isOTPExpired}
                                  />}
                                  {idx === array.length - 1 &&
                                    !this.state.isOTPExpired && (
                                      <div className="message-timer time Tnumber">
                                        {ReactHtmlParser(OTPExpiredMessage)}
                                      </div>
                                    )}
                                </>
                              );
                            }
                          )}
                        </BotMessageButtons>  
                      ) : btnElements && inputTypeElements === ""? (
                        <BotMessageButtons>
                          {el.data.ndata.element.Btns.Buttons.map(
                            (btn, bid) => {
                              let fuuid = uuid + "_" + bid;
                              return ["Other","أخرى"].includes(btn.name)?(
                                <div className="btn-break">
                                  <Button
                                    key={bid}
                                    id={fuuid}
                                    classes={"btnClass btnClassNl"}
                                    title={btn.name}
                                    hoverTitle={btn.name}
                                    action={this.props.btnActions}
                                    onTouchEnd={this.props.btnActions}
                                  />
                                </div>
                              ):<>
                                {inputTypeElements==="lastMessage"?
                                <Button
                                  // ref={this.buttonRef}
                                  key={bid}
                                  id={fuuid}
                                  classes={"btnClass"}
                                  title={btn.name}
                                  hoverTitle={btn.name}
                                  action={this.props.btnActions}
                                />
                                :
                                <Button
                                  key={bid}
                                  id={fuuid}
                                  classes={"btnClass"}
                                  title={btn.name}
                                  hoverTitle={btn.name}
                                  action={this.props.btnActions}
                                />}
                              </>
                            }
                          )}
                        </BotMessageButtons>
                      ) : null}                      

                      {dropdownElements ? (
                        <React.Fragment>
                          <BotMessageDropdown isNickname={haveNickname} isMobile={isAnyMobile}>
                            {isAnyMobile?
                                // <RSelect
                                //   className="react-select-container"
                                //   classNamePrefix="react-select"
                                //   options={accOptions}
                                //   isMulti={false}
                                //   placeholder={selectAnOptionLabel}
                                //   name="selSctype"
                                //   onChange={this.props.mobileDropdownChange}
                                //   isSearchable={false}
                                // />
                                <>
                                  <Button
                                    id={`btn${duuid}`}
                                    classes=""
                                    title={selectAnOptionLabel}
                                    hoverTitle={selectAnOptionLabel}
                                    action={this.onClickDDHandler}
                                  />
                                  <div
                                    style={{ display: "none" }}
                                    className={!haveNickname? "dropdown-wrapper adjusted":"dropdown-wrapper"}
                                  >
                                    <OverlayScrollbarsComponent
                                      ref={this.scrollbarRef}
                                      className="dropdown-list"
                                      options={{
                                        overflow: {
                                          x: 'hidden',
                                        },
                                        scrollbars: {
                                          theme: 'os-theme-light',
                                          visibility: 'visible',
                                          autoHide: 'never',
                                        },
                                      }}
                                      defer
                                  >
                                    {accOptions.map(
                                      (dd, ddid) => {
                                        return (
                                          <div key={ddid} data-value={dd.value} className="cust-dd-list" onClick={(e)=>this.props.mobileDropdownChange(e)}>
                                            {dd.label}
                                          </div>
                                        );
                                      }
                                    )}
                                  </OverlayScrollbarsComponent>
                                  </div>
                                </>
                              :
                              <>
                                <Button
                                  id={`btn${duuid}`}
                                  classes=""
                                  title={selectAnOptionLabel}
                                  hoverTitle={selectAnOptionLabel}
                                  action={this.onClickDDHandler}
                                />
                                <div
                                  style={{ display: "none" }}
                                  className={!haveNickname? "dropdown-wrapper adjusted":"dropdown-wrapper"}
                                >
                                  <select
                                    className={""}
                                    id={duuid}                                
                                    size={el.data.ndata.element.dropdown.options.length>=3?this.state.dropdownSize:el.data.ndata.element.dropdown.options.length}
                                    onChange={this.props.dropdownChange}
                                  >
                                    {el.data.ndata.element.dropdown.options.map(
                                      (dd, ddid) => {
                                        return (
                                          <option key={ddid} value={dd.value}>
                                            {dd.name}{dd.nickname && dd.nickname!==""?` - ${dd.nickname}`:""}
                                          </option>
                                        );
                                      }
                                    )}
                                  </select>
                                </div>
                              </>}
                            
                          </BotMessageDropdown>
                        </React.Fragment>
                      ) : null}
                      
                      {userParamsElements ? (
                        <BotMessageButtons>
                          {el.data.ndata.element.userParam.Values.map(
                            (paramv, pid) => {
                              let ch = "";
                              if (pid === 0) {
                                fullName = paramv.value || "test";
                              }
                              if (pid === 1) {
                                mobileNumber = paramv.value || "00000000";
                              }
                              if (pid === 2) {
                                contractNumber = paramv.value || "11111111";
                              }
                              if (pid === 3) {
                                if (paramv.value === "") {
                                  ch =
                                    "+%0ACustomer%3A+hi+%0ABot%3A++%D8%AD%D9%8A%D8%A7%D9%83+%D8%A7%D9%84%D9%84%D9%87+%E2%80%8B%E2%80%8B+%D9%83%D9%8A%D9%81+%D8%A3%D9%82%D8%AF%D8%B1+%D8%A3%D8%B3%D8%A7%D8%B9%D8%AF%D9%83%D8%9F";
                                } else {
                                  ch = paramv.value;
                                }
                                chatTranscript = ch;
                              }
                              if (paramv.name === 'entryPointId') entryPointId = paramv.value;
                              if (paramv.name === 'templateName') templateName = paramv.value;
                              if (paramv.name === 'locale') locale = paramv.value;
                            }
                          )}
                          <Button
                            key={uuid}
                            id={duuid}
                            classes="btnAgentLink"
                            title={agentBtnTitle}
                            hoverTitle={agentBtnTitle}
                            action={this.props.btnActions}
                            fname={fullName}
                            mobile={mobileNumber}
                            contractno={contractNumber}
                            chathistory={chatTranscript}
                            entryPointId={entryPointId}
                            templateName={templateName}
                            locale={locale}
                          />
                        </BotMessageButtons>
                      ) : null}

                      {accParamsElements ||
                      accNameParamsElements ||
                      billParamsElements ? (
                        <>
                          {feedBtnElements ? (
                            <>
                              <BotMessageText
                                classN="twof"
                                copyBtnHandler={this.props.copyBtnHandler}
                                editBtnHandler={this.props.editBtnHandler}
                                botTitle={this.props.botTitle}
                                isIcon={true}
                              >
                                {ReactHtmlParser(msgs[0].text)}
                              </BotMessageText>
                              <BotMessageTextNoIcon classN="message-card">
                                <CardElement
                                  data={card_data}
                                  language={this.props.language}
                                  downloadAction={this.handleExportPDF}
                                  isDownload={this.state.isDownload}
                                  rawData={card_rawdata}
                                  cardType={inputTypeElements}
                                />
                              </BotMessageTextNoIcon>
                            </>
                          ) : (
                            <BotMessageText
                              classN="message-card"
                              botTitle={this.props.botTitle}
                              isIcon={true}
                            >
                              <CardElement
                                data={card_data}
                                language={this.props.language}
                                downloadAction={this.handleExportPDF}
                                isDownload={this.state.isDownload}
                                rawData={card_rawdata}
                                cardType={inputTypeElements}
                              />
                            </BotMessageText>
                          )}
                        </>
                      ) : null}

                      {feedBtnElements ? (
                        <>
                          {accParamsElements ||
                          accNameParamsElements ||
                          billParamsElements ? (
                            <BotMessageText
                              classN="twof"
                              copyBtnHandler={this.props.copyBtnHandler}
                              editBtnHandler={this.props.editBtnHandler}
                              botTitle={this.props.botTitle}
                              isIcon={true}
                            >
                              {ReactHtmlParser(msgs[1].text)}
                            </BotMessageText>
                          ) : (
                            <> </>
                          )}
                          <BotMessageFeedbackButtons>
                            {/* {console.log(el.data.ndata.element.Btns.Buttons)} */}
                            {el.data.ndata.element.feedbackBtn.options.map(
                              (btn, bid) => {
                                let fuuid = uuid + "_" + bid;
                                let hClass = `highlight-${parseInt(btn.value, 10)}`;
                                let btnIntVal = parseInt(btn.value, 10);
                                return (
                                  <Button
                                    key={bid}
                                    id={fuuid}
                                    classes={`btnFeedClass feedback-button ${hClass}`}
                                    // classes={`btnFeedClass feedback-button ${btnIntVal <= feedbackVal ? `mark-${feedbackVal} ${hClass}` : ''}`}
                                    title={btn.name}
                                    hoverTitle={btn.name}
                                    fname={btn.value}
                                    action={this.props.btnActions}
                                    onMouseEnter={this.handleMouseEnter}
                                    onMouseLeave={this.handleMouseLeave}
                                    onTouchEnd={this.props.btnActions}
                                    svg="true"
                                  >
                                    {btn.value === "1" ? (
                                      <VeryDissatisfied text="false"></VeryDissatisfied>
                                    ) : btn.value === "2" ? (
                                      <Dissatisfied text="false"></Dissatisfied>
                                    ) : btn.value === "3" ? (
                                      <Neutral text="false"></Neutral>
                                    ) : btn.value === "4" ? (
                                      <Satisfied text="false"></Satisfied>
                                    ) : btn.value === "5" ? (
                                      <VerySatisfied text="false"></VerySatisfied>
                                    ) : null}
                                  </Button>
                                );
                              }
                            )}
                          </BotMessageFeedbackButtons>
                        </>
                      ) : null}
                    </BotMessageWrap>
                  );
                }
              })
            ) : (
              <Loader botTitle={this.props.botTitle}></Loader>
            )}
          </div>
          <div id="conversation-scroll">
            <div></div>
          </div>
        </PerfectScrollbar>
        {/* <ExtraButtons
          actionHistory={this.props.btnActions}
          actionMenu={() => {
            // console.log("Menu click");
          }}
          language={this.props.language}
          disableBack={this.props.isMainMenu}
          messageCount = {this.state.messageListsData.length}
        /> */}
      </div>
    );
  }
}
MessageContainer.propTypes = {
  children: React.propTypes.node,
  messageLists: React.propTypes.node,
  dropdownChange: React.propTypes.node,
  btnActions: React.propTypes.node,
  language: React.propTypes.node,
  changeHandler: React.propTypes.node,
  isSelected: React.propTypes.node,
  selectedFile: React.propTypes.node,
  btnChangeHandler: React.propTypes.node,
  removeFileHandler: React.propTypes.node,
  acceptFormat: React.propTypes.node,
  filevalue: React.propTypes.node,
};
export default MessageContainer;